
namespace GeniuzPOS.InventoryReport {
    import fld = IcReport05Row.Fields;
    @Serenity.Decorators.registerClass()
    export class IcReport05Grid extends Serenity.EntityGrid<IcReport05Row, any> {
        protected getColumnsKey() { return IcReport05Columns.columnsKey; }
        protected getDialogType() { return IcReport05Dialog; }
        protected getIdProperty() { return IcReport05Row.idProperty; }
        protected getInsertPermission() { return IcReport05Row.insertPermission; }
        protected getLocalTextPrefix() { return IcReport05Row.localTextPrefix; }
        protected getService() { return IcReport05Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];

            let startDate: string = QRreport.QRywcSpecRow.getLookup().itemById["53"].DocMonth +"/"+ QRreport.QRywcSpecRow.getLookup().itemById["54"].DocYear;
            let qa = QRreport.QRywcSpecRow.getLookup().itemById["53"].Qty_AmtFg
            

            var a = ""
            if(qa==0){
                a = "ช่วงเดือน " + startDate 
            }
            if(qa==1){
                a = "ช่วงเดือน " + startDate +"แสดงยอดคงเหลือ  "
            }
            if(qa==1){
                a = "ช่วงเดือน " + startDate +"แสดงมูลค่าคงเหลือ  "
            }

            var a1n = ""
            let a1: string = QRreport.QRywcSpecRow.getLookup().itemById["53"].WhsId;
            if (a1 != null) {
                let pos = InitialData.IcWhsRow.getLookup().itemById[a1].WhsName;
                a1n = a +" ระบุคลัง:" + a1 + " " + pos

            } else {

                a1n = a

            }

            var a2n = ""
            let a2: string = QRreport.QRywcSpecRow.getLookup().itemById["53"].ShopId;
            if (a2 != null) {
                // let pos = InitialData.IcWhsRow.getLookup().itemById[a2].WhsId;
                a2n = a1n +" ระบุร้าน:" + a2 

            } else {

                a2n = ""

            }
            var x = ""
            let x1: string = QRreport.QRywcSpecRow.getLookup().itemById["53"].ShopTypeId;
            if (x1 != null) {
                let pos = InitialData.PsShopTypeRow.getLookup().itemById[x1].ShopTypeName;
                x = a2n +" ระบุประเภทร้าน:" + pos

            } else {

                x = ""

            }
            var y = ""
            let y1 : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].ShopGroupId;
            if (y1 != null) {
                let pos = InitialData.PsShopGroupRow.getLookup().itemById[y1].ShopGroupName;
                y = x +" ระบุกลุ่มร้าน:" + pos

            } else {

                y = ""

            }
            var b1 = ""
            let b1n: string = QRreport.QRywcSpecRow.getLookup().itemById["53"].SkuCode;
            if (b1n != null) {
                let pos = Product.CsSkuRow.getLookup().itemById[b1n].SkuCode;
                b1 = y+" ระบุสินค้า:" + b1n + " " + pos

            } else {

                b1 =y

            }
            var b = ""
            let find: string = QRreport.QRywcSpecRow.getLookup().itemById["53"].CatCode;
            if (find != null) {
                let pos = Product.CsCategoryRow.getLookup().itemById[find].CatName;
                b = b1 + " ระบุหมวดสินค้า:" + find + " " + pos

            } else {

                b = b1

            }
            var c = ""
            let cf : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].SubCat1Code;


            if (cf != null) {
                let cn = Product.CsSubCategory1Row.getLookup().itemById[cf].SubCat1Name;
                c = b + " ระบุหมวดสินค้า2:" + cf + " " + cn

            } else {

                c = b

            }

            var d = ""
            let df : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].SubCat2Code;


            if (df != null) {
                let dn = Product.CsSubCategory2Row.getLookup().itemById[df].SubCat2Name;
                d = c + " ระบุหมวดสินค้า3:" + df + " " + dn

            } else {

                d = c

            }
            var e = ""
            let ef : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].BrandCode;


            if (ef != null) {
                let en = Product.CsBrandRow.getLookup().itemById[ef].BrandName;
                e = d + " ระบุแบรนด์:" + en

            } else {

                e = d

            }
            var f = ""
            let ff : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].StyleId;


            if (ff != null) {
                let fn = Product.CsStyleRow.getLookup().itemById[ff].StyleName;
                f = e + " ระบุแบบ:" + fn

            } else {

                f = e

            }

            var g = ""
            let gf : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].ColorId;
            // let gn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (gf != null) {

                g = f + " ระบุสี:" + gf

            } else {

                g = f

            }
            var h = ""
            let hf : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].SizeId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (hf != null) {

                h = g + " ระบุขนาด:" + hf

            } else {

                h = g

            }
            var ii = ""
            let iif : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].TasteId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (iif != null) {

                ii = h + " ระบุกลิ่น/รส:" + iif

            } else {

                ii = h

            }
            var j = ""
            let jf : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].MatTypeId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (jf != null) {

                j = ii + " ระบุวัสดุ:" + jf

            } else {

                j = ii

            }
            var k = ""
            let kf : string= QRreport.QRywcSpecRow.getLookup().itemById["53"].SupplId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (kf != null) {

                k = j + " ระบุผู้จำหน่าย:" + kf

            } else {

                k = j

            }
            var l = ""
            let lf = QRreport.QRywcSpecRow.getLookup().itemById["53"].ConsignFg;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (lf != null) {

                if (lf = 0) {
                    l = k + " สินค้าปกติเท่านั้น"
                } else {
                    l = k + " สินค้าฝากขายเท่านั้น"
                }

            } else {

                l = k

            }

            descriptions.push(l);
            
            return [descriptions, gridColumns];
        }
        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["WhsId","CatName"]);
        }


        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcReport05Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'สรุปการเคลื่อนไหวสต๊อกสินค้าแจกแจงแต่ละคลัง'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "SkuCode", title: "รหัสสินค้า", cellWidth: 20, },
                1: { field: "SkuDesc", title: "ชื่อ", cellWidth: 44, overflow: 'linebreak' },
                2: { field: "WhsId", title: "คลัง", cellWidth: 10,  },
                3: { field: "WhsName", title: "ชื่อคลัง", cellWidth: 15  ,overflow: 'linebreak'},
                4: { field: "DateMonth", title: "เดือน", isHidden: true },
                5: { field: "DateYear", title: "ปี", isHidden: true},
                6: { field: "ShopGroupId", title: "กลุ่มร้าน", isHidden: true},
                7: { field: "ShopId", title: "ร้านค้า", isHidden: true},                
                
                8: { field: "BrandCode", title: "ยี่ห้อ", isHidden: true},
                9: { field: "StyleId", title: "แบบ", isHidden: true },
                10: { field: "SizeId", title: "ขนาด", isHidden: true },
                11: { field: "ColorId", title: "สี", isHidden: true },
                12: { field: "SupplId", title: "ผู้จำหน่าย", isHidden: true },
                13: { field: "SupplName", title: "ผู้จำหน่าย", isHidden: true},
                14: { field: "CatCode", title: "หมวดสินค้า", isHidden: true },
                15: { field: "CatName", title: "หมวดสินค้า", isHidden: true},
                16: { field: "SubCat1Code", title: "หมวดสินค้า-2", isHidden: true },
                17: { field: "SubCat1Name", title: "หมวดสินค้า-2", isHidden: true},
                18: { field: "SubCat2Code", title: "หมวดสินค้า-3", isHidden: true },
                19: { field: "SubCat2Name", title: "หมวดสินค้า-3", isHidden: true },
                20: { field: "TasteId", title: "กลิ่น/รส", isHidden: true },
                21: { field: "MatTypeId", title: "วัสดุที่ใช้", isHidden: true },
                22: { field: "ConsignFg", title: "สินค้าฝากขาย?", isHidden: true },

                23: { field: "GroupType", title: "type", cellWidth: 9,  },
                24: { field: "EomIn", title: "ยกมา", cellWidth: 18, halign: 'right', aggregate: "sum"},
                25: { field: "IcReceive", title: "รับเข้า", cellWidth: 18, halign: 'right', aggregate: "sum"},
                26: { field: "IcReturnOut", title: "ส่งคืน", cellWidth: 18, halign: 'right', aggregate: "sum"},
                27: { field: "IcSold", title: "เบิกขาย", cellWidth: 18, halign: 'right', aggregate: "sum"},
                28: { field: "IcReturnIn", title: "รับคืน", cellWidth: 18, halign: 'right', aggregate: "sum"},
                29: { field: "IcAdjIn", title: "ปรับเพิ่ม", cellWidth: 18, halign: 'right', aggregate: "sum"},
                30: { field: "IcAdjOut", title: "ปรับลด", cellWidth: 18, halign: 'right', aggregate: "sum"},
                31: { field: "IcTranIn", title: "โอนรับ", cellWidth: 18, halign: 'right', aggregate: "sum"},
                32: { field: "IcTranOut", title: "โอนจ่าย", cellWidth: 18, halign: 'right', aggregate: "sum"},
                33: { field: "SumOut", title: "ยกไป", cellWidth: 18, halign: 'right', aggregate: "sum"},

            }

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     // pageSize:{width:210,height:297},
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec_icrp05/edit/53';
                        return false;
                    },
                }
            );
                       
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true;
            opt.showFooterRow = true;
            return opt;
        }
        // protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

        //     let filters = super.getQuickFilters();
        //     Q.first(filters, x => x.field == fld.GroupType).init = w => {
        //         (w as Serenity.EnumEditor).value = "จำนวน";
        //         ;
        //     };
    
            
    
        //     return filters;
        // }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
           

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('EomIn'),
                    new Slick.Aggregators.Sum('IcReceive'),
                    new Slick.Aggregators.Sum('IcReturnOut'),
                    new Slick.Aggregators.Sum('IcSold'),
                    new Slick.Aggregators.Sum('IcReturnIn'),
                    new Slick.Aggregators.Sum('IcAdjIn'),
                    new Slick.Aggregators.Sum('IcAdjOut'),
                    new Slick.Aggregators.Sum('IcTranIn'),
                    new Slick.Aggregators.Sum('IcTranOut'),
                    new Slick.Aggregators.Sum('SumOut')
                ]
            });
            return grid;
        }
    }
}